import EBookStar from '@assets/icons/e-book-star.svg'
import { Icon } from './Icon'

export const EBookStarIcon = Icon(EBookStar)
